import { CookieAcceptanceService } from './front/service/cookie-acceptance.service';
import { RokezzzTitleService } from 'src/app/rokezzz/titles/services/title.service';
import { AfterViewInit, Component, HostListener, Inject, LOCALE_ID } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { WindowExtension } from './rokezzz/window/api/window-extension';
import { RokezzzVisibilityService } from './rokezzz/window/services/visibility.service';
import { RokezzzWindowResizeService } from './rokezzz/window/services/window-resize.service';
import { RokezzzWindowScrollService } from './rokezzz/window/services/window-scroll.service';
import { RokezzzWindowService } from './rokezzz/window/services/window.service';
import { globals } from './globals';
import { RokezzzLocalStorageService } from './rokezzz/local-storage/services/local-storage.service';
import { RokezzzPlatformService } from './rokezzz/platform/services/platform.service';
import { CookiePopupComponent } from './front/components/cookie-popup/cookie-popup.component';
import { CookiePopupDetailsComponent } from './front/components/cookie-popup-details/cookie-popup-details.component';
import { RokezzzGtagService } from './rokezzz/gtag/services/gtag.service';

@Component({
    selector: '#app-root',
    templateUrl: './app.component.html',
    standalone: true,
    imports: [
        RouterOutlet,
        CookiePopupComponent,
        CookiePopupDetailsComponent
    ],
})
export class AppComponent implements AfterViewInit {
    private windowExtension: WindowExtension;
    private document: Document;

    public constructor(
        @Inject(LOCALE_ID) public localeId: string,
        private readonly localStorageService: RokezzzLocalStorageService,
        private readonly windowService: RokezzzWindowService,
        private readonly windowScrollService: RokezzzWindowScrollService,
        private readonly windowResizeService: RokezzzWindowResizeService,
        private readonly visibilityService: RokezzzVisibilityService,
        private readonly titleService: RokezzzTitleService,
        private readonly rokezzzPlatformService: RokezzzPlatformService,
        private readonly cookieAcceptanceService: CookieAcceptanceService,
        private readonly gtagService: RokezzzGtagService,
    ) {
        globals.localStorageService = localStorageService;

        this.windowExtension = this.windowService.getWindowExtension();
        this.document = this.windowService.getDocument();

        if (this.windowExtension.loadingInterval) {
            window.clearInterval(this.windowExtension.loadingInterval);
        }

        if (this.rokezzzPlatformService.isPlatformBrowser()) {
            this.titleService.setSegmentZero('Expoglass');
            this.windowResizeService.setSize({
                width: this.windowExtension.innerWidth,
                height: this.windowExtension.innerHeight
            });

            if (!this.cookieAcceptanceService.isCookieSettings()) {
                this.cookieAcceptanceService.isCookiePopupVisible.next(true);
            }
        }
    }

    public ngAfterViewInit(): void {
        if (this.rokezzzPlatformService.isPlatformBrowser() && this.localeId === 'de-DE') {
            this.gtagService.init();
        }
    }

    @HostListener('window:visibilitychange', ['$event'])
    public onWindowVisible(): void {
        this.visibilityService.setWindowVisible(!this.document.hidden);
    }

    @HostListener('window:scroll', ['$event'])
    public onScroll(): void {
        this.windowScrollService.setScroll(this.windowExtension.scrollY);
    }

    @HostListener('window:resize', ['$event'])
    public onResize(): void {
        this.windowScrollService.setScroll(this.windowExtension.scrollY);
        this.windowResizeService.setSize({
            width: this.windowExtension.innerWidth,
            height: this.windowExtension.innerHeight
        });
    }
}
